export const clientContext = (
  context: { [key: string]: unknown } = {},
): { [key: string]: unknown } => ({ ...context, clientName: "federation" });
